// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navigation {
  display: flex;
  flex-direction: row;
  align-items: center;
  z-index: 3;
  justify-content: center;
  gap: 2em;
  justify-self: center;
  align-self: center;
  margin: auto;
  padding: 1em;
  border: 1px solid rgba(237, 220, 210, 0.5);
  background-color: rgba(154, 224, 217, 0.2);
  top: 0.5%;
  border-radius: 4px;
  position: fixed;
  -webkit-backdrop-filter: blur(6px);
          backdrop-filter: blur(6px);
  width: 50%;
  height: 3.5em;
}
.navigation > div > svg {
  cursor: pointer;
  z-index: 1;
  stroke: #ffbcd7;
  color: #0abab5;
}
.navigation_title {
  display: flex;
  flex-direction: row;
  font-family: "Alpino-Black";
  font-size: 2em;
  color: #0abab5;
  z-index: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
}
.navigation_title_img-container {
  width: 2em;
  height: 5em;
}
.navigation_icons > svg {
  margin-right: 1em;
  z-index: 1;
  stroke: #0abab5;
  color: #0abab5;
}

img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

@media (min-width: 390px) {
  .navigation_title {
    font-size: 1.5em;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Navigation/Navigation.scss","webpack://./src/assets/scss/components/_colors.scss","webpack://./src/assets/scss/components/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,UAAA;EACA,uBAAA;EACA,QAAA;EACA,oBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,kCAAA;UAAA,0BAAA;EACA,UAAA;EACA,aAAA;AADF;AAGE;EACE,eAAA;EACA,UAAA;EACA,eCtBS;EDuBT,cC1BY;ADyBhB;AAIE;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,cAAA;EACA,cClCY;EDmCZ,UAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAFJ;AAII;EACE,UAAA;EACA,WAAA;AAFN;AAOI;EACE,iBAAA;EACA,UAAA;EACA,eClDU;EDmDV,cCnDU;AD8ChB;;AAUA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAPF;;AE5CE;EFyDE;IACE,gBAAA;EATJ;AACF","sourcesContent":["@import \"../../assets/scss/components/imports.scss\";\n\n.navigation {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  z-index: 3;\n  justify-content: center;\n  gap: 2em;\n  justify-self: center;\n  align-self: center;\n  margin: auto;\n  padding: 1em;\n  border: 1px solid rgba(237, 220, 210, 0.5);\n  background-color: rgba(154, 224, 217, 0.2);\n  top: 0.5%;\n  border-radius: 4px;\n  position: fixed;\n  backdrop-filter: blur(6px);\n  width: 50%;\n  height: 3.5em;\n\n  & > div > svg {\n    cursor: pointer;\n    z-index: 1;\n    stroke: $pink-color;\n    color: $tiffany-color;\n  }\n\n  &_title {\n    display: flex;\n    flex-direction: row;\n    font-family: \"Alpino-Black\";\n    font-size: 2em;\n    color: $tiffany-color;\n    z-index: 1;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n\n    &_img-container {\n      width: 2em;\n      height: 5em;\n    }\n  }\n\n  &_icons {\n    & > svg {\n      margin-right: 1em;\n      z-index: 1;\n      stroke: $tiffany-color;\n      color: $tiffany-color;\n    }\n  }\n}\n\nimg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n\n@include screen-sm {\n  .navigation {\n    &_title {\n      font-size: 1.5em;\n    }\n  }\n}\n\n@include screen-md {\n\n}\n\n\n@include screen-lg {\n\n}\n\n@include screen-xl {\n\n}\n\n@include screen-2xl {\n\n}","$tiffany-color: #0abab5;\n$dark-tiffany-color: #113935;\n$tiffany-2-color: #9ae0d9;\n$pink-color: #ffbcd7;\n$dark-pink-color: #ff7db1;\n$dark-tan-color: #c99578;\n$tan-color: #eddcd2;\n$white-color: #f3f2ef;\n$black-color: #232223;\n","$screen-sm: 390px;\n$screen-md: 768px;\n$screen-lg: 1024px;\n$screen-xl: 1280px;\n$screen-2xl: 1640px;\n$screen-3xl: 1920px;\n\n@mixin screen-sm {\n  @media (min-width: $screen-sm) {\n    @content;\n  }\n}\n\n@mixin screen-md {\n  @media (min-width: $screen-md) {\n    @content;\n  }\n}\n\n@mixin screen-lg {\n  @media (min-width: $screen-lg) {\n    @content;\n  }\n}\n\n@mixin screen-xl {\n  @media (min-width: $screen-xl) {\n    @content;\n  }\n}\n\n@mixin screen-2xl {\n  @media (min-width: $screen-2xl) {\n    @content;\n  }\n}\n\n@mixin screen-3xl {\n  @media (min-width: $screen-3xl) {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
